/**
 * React context for the DatasetRepository port. Features receive the port —
 * never import createLocalRepository / createHttpRepository themselves.
 */
import { createContext, useContext, type JSX, type ReactNode } from 'react';

import type { DatasetRepository } from '@meridian/core';

const RepositoryContext = createContext<DatasetRepository | null>(null);

export interface RepositoryProviderProps {
  readonly repository: DatasetRepository;
  readonly children: ReactNode;
}

export function RepositoryProvider({ repository, children }: RepositoryProviderProps): JSX.Element {
  return <RepositoryContext.Provider value={repository}>{children}</RepositoryContext.Provider>;
}

export function useRepository(): DatasetRepository {
  const repo = useContext(RepositoryContext);
  if (repo === null) {
    throw new Error('useRepository requires RepositoryProvider');
  }
  return repo;
}
